import Colors from 'assets/Colors';
import Input from 'components/common/Input';
import ColorSelector from 'components/common/ColorSelector';
import CloseIconSmall from 'components/icons/CloseIconSmall';
import DropIcon from 'components/icons/DropIcon';
import { useFormik } from 'formik';
import useCategoryMutations from 'graphql/useCategoryMutations';
import * as Yup from 'yup';

import { BSON } from 'realm-web';
import { useTranslation } from 'react-i18next';
import { useMessaging } from '../../../../context/MessagingContext';
import s from './styles';

function AddCategoryModal({ close, onCategoryCreated }) {
  const { t } = useTranslation();
  const { addCategory, loading } = useCategoryMutations();
  const { setErrorMessage } = useMessaging();

  const { handleSubmit, handleChange, values, isValid, dirty } = useFormik({
    initialValues: {
      _id: new BSON.ObjectId(),
      name: '',
      color: null,
      updateDatetime: new Date(),
      creationDatetime: new Date(),
    },
    onSubmit: (values) => {
      addCategory(values)
        .then((data) => {
          close();
          onCategoryCreated(data);
        })
        .catch((e) => {
          setErrorMessage({ error: e });
        });
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(),
      image: Yup.string().nullable(),
      color: Yup.string().nullable(),
    }),
  });

  return (
    <>
      <s.HeaderContainer>
        <s.CloseButtonWrapper
          onClick={() => {
            close();
          }}
        >
          <CloseIconSmall />
        </s.CloseButtonWrapper>
        <div>{t('Category.addCategory')}</div>
        <s.SaveTextWrapper
          enable={isValid && dirty && !loading}
          onClick={() => handleSubmit()}
        >
          {t('actions.save')}
        </s.SaveTextWrapper>
      </s.HeaderContainer>
      <s.BodyWrapper>
        <s.LeftContainer>
          <s.Title>{t('Category.category')}</s.Title>
          <s.Line />
          <s.SubTitle>{t('Category.fields.name.label')}</s.SubTitle>
          <Input
            style={{
              marginBottom: '20px',
            }}
            name="name"
            onChange={handleChange}
            value={values.name}
          />
        </s.LeftContainer>
        <div>
          <s.Title>{t('Category.fields.color.label')}</s.Title>
          <s.ColorWrapper color={values.color}>
            <DropIcon color={values.color ? undefined : Colors.GREY} />
          </s.ColorWrapper>
          <ColorSelector
            handleChange={(value) => {
              handleChange({
                target: {
                  name: 'color',
                  value,
                },
              });
            }}
          />
        </div>
      </s.BodyWrapper>
    </>
  );
}

export default AddCategoryModal;
